import React from "react";
import { connect, useDispatch } from "react-redux";
import { Alert } from "antd";
import { AnyObject, Error } from "@triare/auth-redux/dist/saga/common";
import { User } from "@triare/auth-redux/dist/saga/auth/useMe";
import { AlertProps } from "antd/es/alert";
import { RootState } from "../../../../../../../store";
import { /* actions, */ moduleName } from "../../../../../../../store/auth";

export interface AlertSuccessProps extends AlertProps {
  disable?: boolean;
  authorized: boolean;
  response: AnyObject | null;
  user: User | null;
  error: Error | null;
}

function AlertSuccess({
  disable = false,
  authorized,
  user,
  error,
  response,
  ...props
}: AlertSuccessProps): React.ReactNode {
  const dispatch = useDispatch();

  if (disable === false && authorized && user && !error && response) {
    return (
      <Alert
        type="success"
        message="Signed in successfully!"
        closable
        // onClose={() => dispatch({
        //   type: actions.signUpClear.toString(),
        // })}
        {...props}
      />
    );
  }

  return null;
}

export default connect((state: RootState) => ({
  authorized: state[moduleName].authorized,
  error: state[moduleName].signUp.error,
  user: state[moduleName].user,
}))(AlertSuccess);
